import React, { Component } from 'react'

import { Row, Col } from 'react-bootstrap';

export default class PastCompetitionData extends Component {
    render() {
        return (
            <div>
                <hr />
                <Row>
                    <Col lg={true} xs={5}>
                        <h3>Teams</h3>
                        <h4>{this.props.teams}</h4>
                    </Col>
                    <Col lg={true} xs={5}>
                        <h3>Physics Topic</h3>
                        <h4>{this.props.physicsTopic}</h4>
                    </Col>
                    { this.props.chemistryTopic != null ? <Col lg={true} xs={5}><h3>Chemistry Topic</h3><h4>{this.props.chemistryTopic}</h4></Col> : "" }
                    <Col lg={true} xs={5}>
                        <h3>Winner</h3>
                        <h4>{this.props.winner}</h4>
                    </Col>
                </Row>
                <hr />
            </div>
        )
    }
}
